export default function(x) {
  return x<0 ? -1 : 1;
}


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/proj4/lib/common/sign.js
// module id = ../../../../proj4/lib/common/sign.js
// module chunks = vendor